import React, {useState, useEffect} from 'react';
import {
    Bullseye,
    Spinner,
    Page,
    Gallery,
    PageSection,
    PageSectionVariants,
    TextContent,
    Text
} from '@patternfly/react-core';
import {ClientRepresentation, fetchAccountConsoles} from './API';
import {ConsoleCard} from './components/Card';
import SignpostHeader from "./components/SignpostHeader";
interface L1On {
    title: string;
    description: string;
}

interface L10nList {
    [key: string]: L1On
}

export enum Language {
    CZECH = 'czech',
    ENGLISH = 'english'
}

const App = () => {

    const messages: L10nList = {
        "czech": {
            'title': 'Správa účtu',
            'description': 'Rozcestník jednotlivých konzolí účtu'
        },
        "english": {
            'title': 'Account Management',
            'description': 'Account Consoles Signpost'
        }
    };
    const[loading, setLoading] = useState(false);
    const[accountConsoles, setAccountConsoles] = useState<ClientRepresentation[]>([]);
    const[l10n, setL10n] = useState<string>(Language.CZECH);
    const getFilteredConsoles = (consoles: any) => {
        //return consoles.filter(
        //  (item: any) => item.baseUrl === '/realms/extern/account/'
	//              || item.baseUrl === '/realms/trask/account/'
        //)
        return consoles
    }

    useEffect(() => {
        setLoading(true);
        fetchAccountConsoles(l10n as Language).then((consoles) => {
            setAccountConsoles(getFilteredConsoles(consoles));
            setLoading(false);
        });
    }, [l10n]);

    const onChangeL10n = () => {
        setL10n(l10n === Language.CZECH ? Language.ENGLISH : Language.CZECH);
    }

    return (
        <Page header={<SignpostHeader onChangeL10n={onChangeL10n} l10n={l10n}/>} >
            <PageSection variant={PageSectionVariants.light}>
                <TextContent>
                    <Text component="h1">{messages[l10n] && messages[l10n].title}</Text>
                    <Text component="p">{messages[l10n] && messages[l10n].description}</Text>
                </TextContent>
            </PageSection>
            <PageSection isFilled={true}>
                {loading &&
                    <Bullseye>
                        <Spinner/>
                    </Bullseye>
                }
{
    !loading && accountConsoles && accountConsoles.length > 0 &&
    <Gallery hasGutter>
        {
            accountConsoles.map(
                accountConsole =>
                    <ConsoleCard
			key={accountConsole.description[l10n as Language]}
                        accountConsole={accountConsole}
                    />
            )
        }
    </Gallery>
}

            </PageSection>
        </Page>
    );
}

export default App;
